import { Collapsible } from '@components/std-components/Collapsible'
import Typography from '@components/std-components/Typography'
import { CircularLoading } from '@components/UI-Components/CircularLoading'
import { OrderType } from '@modules/common/models/enums'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { stores } from '@stores'
import isEmpty from 'lodash/isEmpty'
import { useObserver } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import * as css from './OrderNavigation.css'

export const OrderNavigation: React.FC<any> = () => {
  return useObserver(function useHook() {
    const {
      uiStore: {
        dataStore: {
          setClientOrderOpenState,
          clientOrdersMap,
          clientOrders,
          fetchClientOrderNames,
          isNavDataLoading,
          isClientMaster
        },
        handleOrderNavigation,
        isClientOrderDisabled
      }
    } = useOrderContext()
    const {
      nav: { history }
    } = stores

    const isCMView = history.location.pathname.includes('wholesale')

    useEffect(() => {
      if (isEmpty(clientOrders)) {
        fetchClientOrderNames()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
      <div className={css.navWrapper}>
        {isNavDataLoading && <CircularLoading />}
        {!isEmpty(clientOrders) &&
          clientOrders?.map(order => {
            return (
              <div key={order.id}>
                {!isClientMaster ? (
                  <Collapsible
                    isOpen={clientOrdersMap[order.id]}
                    title={order.name || 'NA'}
                    variant='subHeading2'
                    customTitleClass={css.customTitleClass}
                    rowDisabled={isClientOrderDisabled(order) || isCMView}
                    onRowClick={() =>
                      handleOrderNavigation(
                        order.id,
                        OrderType.Client,
                        '',
                        order?.buyingSession?.id
                      )
                    } // navigate
                    onIconClick={() => setClientOrderOpenState(order.id)}
                  >
                    <div className={css.doorWrapper}>
                      {order.doorOrders?.map(doorOrder => {
                        return (
                          !doorOrder?.deleted && (
                            <div
                              key={doorOrder.door.id}
                              onClick={() =>
                                handleOrderNavigation(
                                  doorOrder.id,
                                  OrderType.Door,
                                  order.id
                                )
                              }
                              className={css.doorName}
                            >
                              <Typography
                                variant='subHeading2'
                                color='primary'
                                classes={'text-ellipsis'}
                              >
                                {doorOrder.door.name}
                              </Typography>
                            </div>
                          )
                        )
                      })}
                    </div>
                  </Collapsible>
                ) : (
                  !order?.deleted && (
                    <div>
                      <div
                        key={order.id}
                        onClick={() =>
                          handleOrderNavigation(
                            order.id,
                            OrderType.Client,
                            '',
                            order?.buyingSession?.id
                          )
                        }
                        className={css.doorName}
                      >
                        <Typography
                          variant='subHeading2'
                          color='primary'
                          classes={'text-ellipsis'}
                        >
                          {order.name || 'NA'}
                        </Typography>
                      </div>
                    </div>
                  )
                )}
              </div>
            )
          })}
      </div>
    )
  })
}
